import { nanoid } from 'nanoid';
import React from 'react';

import { TextParagraph } from './Paragraph';
import { Title } from './Title';

export interface TextProps {
  node: {
    fieldDescription?: string;
    fieldTitle?: string;
    titleLevel?: number;
  };
}

export const TitleDescription = ({ node }: TextProps) => {
  const { fieldTitle, titleLevel, fieldDescription } = node;

  return (
    <div key={nanoid()} className="blog-portfolio-paragraphs">
      <Title title={fieldTitle} titleLevel={titleLevel} />
      <TextParagraph node={{ fieldDescription }} />
    </div>
  );
};
